module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "produk-form"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Pembayaran")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/produk'
      }
    }
  }, [_vm._v("Produk")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(!_vm.$route.query.id ? "Buat" : "Update") + " Produk")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("\n      " + _vm._s(!_vm.$route.query.id ? "Buat" : "Update") + " Produk\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("\n              " + _vm._s(!_vm.$route.query.id ? "Buat" : "Update") + " Produk\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(this.errors.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((this.errors), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v("\n                  " + _vm._s(message) + "\n                ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Tipe Produk")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.type),
      expression: "data.type"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.$route.query.id
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- Pilih Tipe Produk --")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.type.SUBSCRIPTION
    }
  }, [_vm._v("Subscription")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.type.TICKET
    }
  }, [_vm._v("Tiket")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.type.KUOTA
    }
  }, [_vm._v("Kuota")])])])]), _vm._v(" "), (_vm.data.type) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Nama Produk")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.title),
      expression: "data.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Platform")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.platform),
      expression: "data.platform"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "platform", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "ANDROID"
    }
  }, [_vm._v("Android")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "WEB"
    }
  }, [_vm._v("Web")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ALL"
    }
  }, [_vm._v("Semua")])])])]), _vm._v(" "), (_vm.data.type === _vm.type.SUBSCRIPTION) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Kelas")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.jenjang),
      expression: "jenjang"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.jenjang = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "SD"
    }
  }, [_vm._v("SD")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SMP"
    }
  }, [_vm._v("SMP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SMA"
    }
  }, [_vm._v("SMA")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grade),
      expression: "grade"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.grade = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.jenjangList), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item
      }
    }, [_vm._v("\n                            " + _vm._s(item) + "\n                          ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Fitur")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-xs-12",
    staticStyle: {
      "display": "flex",
      "flex-flow": "column"
    }
  }, [_vm._l((_vm.featureList), function(item, index) {
    return _c('span', {
      key: index
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.features),
        expression: "features"
      }],
      staticClass: "checkbox m-r-5",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item,
        "checked": Array.isArray(_vm.features) ? _vm._i(_vm.features, item) > -1 : (_vm.features)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.features,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.features = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.features = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.features = $$c
          }
        }
      }
    }), _c('span', {
      staticClass: "f-s-14 f-w-700 m-r-10"
    }, [_vm._v("\n                            " + _vm._s(item === "INSTANT_TRYOUT" ?
      "Tryout Instan" :
      item === "CONSULTATION" ?
      "Konsultasi" :
      item === "DUEL" ?
      "Duel" :
      item === "ITEM_BANK" ?
      "Bank Soal" :
      item === "SCHEDULED_TRYOUT" ?
      "Tryout Terjadwal" :
      item === "VIDEO" ?
      "Video Pembelajaran" :
      "") + "\n                          ")])])
  }), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.featBimbel),
      expression: "featBimbel"
    }],
    staticClass: "checkbox m-r-5",
    attrs: {
      "type": "checkbox",
      "value": "true"
    },
    domProps: {
      "checked": Array.isArray(_vm.featBimbel) ? _vm._i(_vm.featBimbel, "true") > -1 : (_vm.featBimbel)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.featBimbel,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "true",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.featBimbel = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.featBimbel = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.featBimbel = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "f-s-14 f-w-700 m-r-10"
  }, [_vm._v("Bimbel")])])], 2), _vm._v(" "), (_vm.featBimbel) ? _c('div', {
    staticClass: "col-md-5 col-xs-12",
    staticStyle: {
      "display": "flex",
      "flex-flow": "column",
      "max-height": "200px",
      "overflow": "auto"
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.bimbelList.length === 0) ? _c('span', [_vm._v("Tidak ada bimbel yang bisa dipilih "), _c('br'), _vm._v("Silahkan\n                          pilih kelas lain atau buat bimbel baru")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.bimbelList), function(item, index) {
    return _c('span', {
      key: index
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.bimbels),
        expression: "bimbels"
      }],
      staticClass: "checkbox m-r-5",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.id,
        "checked": Array.isArray(_vm.bimbels) ? _vm._i(_vm.bimbels, item.id) > -1 : (_vm.bimbels)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.bimbels,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.bimbels = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.bimbels = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.bimbels = $$c
          }
        }
      }
    }), _c('span', {
      staticClass: "f-s-14 f-w-700 m-r-10"
    }, [_vm._v(_vm._s(item.name))])])
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Durasi (Bulan)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.value),
      expression: "data.value"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "9999"
    },
    domProps: {
      "value": (_vm.data.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "value", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Bonus Tiket")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_vm._v("\n                        " + _vm._s(_vm.data.bonus) + "\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.bonus_value),
      expression: "data.bonus_value"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.data.bonus_value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "bonus_value", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Harga")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("Rp")]), _vm._v(" "), _c('vue-numeric', {
    staticClass: "form-control",
    attrs: {
      "separator": ","
    },
    model: {
      value: (_vm.data.net_price),
      callback: function($$v) {
        _vm.$set(_vm.data, "net_price", $$v)
      },
      expression: "data.net_price"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(".00")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Harga Coret")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("Rp")]), _vm._v(" "), _c('vue-numeric', {
    staticClass: "form-control",
    attrs: {
      "separator": ","
    },
    model: {
      value: (_vm.data.price),
      callback: function($$v) {
        _vm.$set(_vm.data, "price", $$v)
      },
      expression: "data.price"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(".00")])], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.data.type === _vm.type.TICKET || _vm.data.type === _vm.type.KUOTA) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("\n\t\t\t\t\t  " + _vm._s(_vm.data.type === _vm.type.KUOTA ? 'Jumlah Kuota' : 'Jumlah Tiket') + "\n\t\t\t\t\t  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.value),
      expression: "data.value"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.data.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "value", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Bonus Tiket")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.bonus_value),
      expression: "data.bonus_value"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.data.bonus_value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "bonus_value", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Harga")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("Rp")]), _vm._v(" "), _c('vue-numeric', {
    staticClass: "form-control",
    attrs: {
      "separator": ","
    },
    model: {
      value: (_vm.data.net_price),
      callback: function($$v) {
        _vm.$set(_vm.data, "net_price", $$v)
      },
      expression: "data.net_price"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(".00")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Harga Coret")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("Rp")]), _vm._v(" "), _c('vue-numeric', {
    staticClass: "form-control",
    attrs: {
      "separator": ","
    },
    model: {
      value: (_vm.data.price),
      callback: function($$v) {
        _vm.$set(_vm.data, "price", $$v)
      },
      expression: "data.price"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(".00")])], 1)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Deskripsi")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('ckeditor', {
    attrs: {
      "editor": _vm.editor,
      "config": _vm.editorConfig
    },
    model: {
      value: (_vm.data.description),
      callback: function($$v) {
        _vm.$set(_vm.data, "description", $$v)
      },
      expression: "data.description"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.data.description) ? _c('span', [_c('i', [_vm._v("(" + _vm._s(_vm.characterCounter(_vm.data.description)) + "\n                          karakter)")])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.data.picture) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.data.picture
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        return _vm.handleChangePicture($event)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.status),
      expression: "data.status"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- Pilih Status --")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.status.PUBLISH
    }
  }, [_vm._v("Publish")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.status.UNPUBLISH
    }
  }, [_vm._v("Unpublish")])])])])]) : _vm._e()])]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.data.type) ? _c('div', {
    staticClass: "pull-right"
  }, [(!_vm.$route.query.id) ? _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveData()
      }
    }
  }, [_vm._v("\n                Simpan\n              ")]) : _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.editData()
      }
    }
  }, [_vm._v("\n                Update\n              ")])]) : _vm._e()])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('h5', [_vm._v("Pilih Daftar Bimbel")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Gambar"), _c('br'), _vm._v("(Max 1MB)")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33a153f9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pembayaran/ProdukForm.vue
// module id = 1319
// module chunks = 0